import React from "react";
import clsx from "clsx";

import Radio from "@material-ui/core/Radio";
import Grid from "@material-ui/core/Grid";

import useStyles from "./styles";
import images from "../../../../../../../images";
import {isRequiredQuestion, isValidValue} from "../../../../../utils";
import {FIELD_REQUIRED_MSG} from "../../../../../constants";
import FormHelperText from "@material-ui/core/FormHelperText";
import WarningTooltip from "../../../../../../../components/WarningTooltip";
import {DisabledReasonTooltip} from "../../../../../../../components/Tooltip";

const chartImages = [
  images.risk_profiling.chart_defensiv,
  images.risk_profiling.chart_ausgeglichen,
  images.risk_profiling.chart_offensiv
];

function isChartQuestionValid(question, step, afterChange, service) {
  if (isRequiredQuestion(question)) {
    const isValid = isValidValue(question.answer);
    question.error = isValid ? null : FIELD_REQUIRED_MSG;

    return isValid;
  }

  return true;
}

export const ChartSelectQuestionMethods = {
  required: isRequiredQuestion,
  valid: isChartQuestionValid
}

const ChartSelectQuestion = props => {
  const {
    question,
    onAnswerChange,
    dataService,
  } = props;

  const classes = useStyles();
  const isNewDesign = dataService.isNewDesign;

  const options = question.config.choices || [];
  const value = question.answer;

  const handleChange = (value) => {
    question.error = null;  // clean error
    onAnswerChange(question.uid, value);
  };

  return (
    <>
      {question.error && (
        <FormHelperText
          error={true}
          classes={{
            error: classes.errorContainer
          }}>{ question.error }</FormHelperText>
      )}
      <Grid container spacing={2} alignItems={"center"} justify={options.length === 1 ? "center" : undefined}>
        {options.map((option, index) => (
          <DisabledReasonTooltip key={option.uid} title={option.disabled && option.disabledReason}>
            <Grid  item xs={12} md={6} lg={4} xl={3}>
              <div
                className={clsx(
                  classes.item, isNewDesign && 'newDesign',
                  option.disabled && 'disabled',
                  option.uid === value && classes.selected
                )}
                onClick={() => handleChange(option.uid)}
              >
                <div className={classes.title}>
                  <span className={classes.name}>
                    {isNewDesign && <Radio color="primary" checked={option.uid === value} />}
                    {option.text}
                  </span>
                  {!!option.info && (
                    <WarningTooltip title={option.info} iconClassName={classes.infoIcon} interactive />
                  )}
                </div>
                <div className={classes.imageContainer}>
                  <img
                    className={classes.chartImage}
                    alt={option.text}
                    src={option.hasOwnProperty('image') ? option.image : chartImages[index]}
                  />
                </div>
              </div>
            </Grid>
          </DisabledReasonTooltip>
        ))}
      </Grid>
    </>
  );
};

export default ChartSelectQuestion;